/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { __core_private__ as r } from '@angular/core';
export var RenderDebugInfo = r.RenderDebugInfo;
export var ReflectionCapabilities = r.ReflectionCapabilities;
export var DebugDomRootRenderer = r.DebugDomRootRenderer;
export var reflector = r.reflector;
export var NoOpAnimationPlayer = r.NoOpAnimationPlayer;
export var AnimationPlayer = r.AnimationPlayer;
export var AnimationSequencePlayer = r.AnimationSequencePlayer;
export var AnimationGroupPlayer = r.AnimationGroupPlayer;
export var AnimationKeyframe = r.AnimationKeyframe;
export var AnimationStyles = r.AnimationStyles;
export var prepareFinalAnimationStyles = r.prepareFinalAnimationStyles;
export var balanceAnimationKeyframes = r.balanceAnimationKeyframes;
export var clearStyles = r.clearStyles;
export var collectAndResolveStyles = r.collectAndResolveStyles;
//# sourceMappingURL=private_import_core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser/src/private_import_core.js
// module id = 317
// module chunks = 0